<div class="flex flex-col gap-2">
  <div class="flex items-center text-neutral-500">
    <strong class="text-sm text-neutral-900 font-semibold">Branch</strong>
    @if (contextMenuItems().length > 0) {
      <div class="ml-auto">
        <button
          (click)="branchContextMenu.toggle($event)"
          class="flx-ds secondary small icon-btn"
          flxButton
          icon="center"
          data-testId="branch-menu-button"
        >
          <i
            class="ph-bold ph-dots-three-vertical"
            flxIcon
          ></i>
        </button>
      </div>
    }
  </div>
  <div class="flex items-center gap-2">
    <flx-branch-name
      [branchName]="applicationVersion().branchName"
      [branchOrder]="applicationVersion().branchArchived ? null : applicationVersion().branchOrder"
      class="flex"
      emphasis="selected"
    />

    @if (applicationVersion().branchArchived) {
      <flx-branch-state
        [status]="applicationVersion().status"
        [isArchived]="true"
        data-testId="archived-branch-chip"
      />
    }
  </div>
  <div class="grid grid-cols-[auto_1fr] gap-2 items-center text-xs">
    @if (createdFromVersion(); as createdFrom) {
      Created from:
      <flx-branch-name
        [branchName]="createdFrom.branchName"
        [branchOrder]="createdFrom.branchArchived ? null : createdFrom.branchOrder"
        class="flex"
        [truncate]="true"
      />
    }
    @let branchCreatedBy = applicationVersion().branchCreatedBy;
    Created by:
    <div class="flex items-center gap-1">
      <span
        [pTooltip]="branchCreatedBy.firstName + ' ' + branchCreatedBy.lastName"
        class="commit-author text-neutral-900"
        tooltipStyleClass="text-xs"
      >
        {{ branchCreatedBy | flxUserInitials }}
      </span>
      {{ applicationVersion().branchCreatedDate | flxDateFormat: 'dd MMM yyyy' : 'h:mm a' : ', ' }}
    </div>

    @if (applicationVersion().branchArchived) {
      Archived by:
      @let branchArchivedBy = applicationVersion().branchArchivedBy;
      @let branchArchivedDate = applicationVersion().branchArchivedDate;
      <div class="flex items-center gap-1">
        <span
          [pTooltip]="branchArchivedBy.firstName + ' ' + branchArchivedBy.lastName"
          class="commit-author text-neutral-900"
          tooltipStyleClass="text-xs"
        >
          {{ branchArchivedBy | flxUserInitials }}
        </span>
        <span>{{ branchArchivedDate | flxDateFormat: 'dd MMM yyyy' : 'h:mm a' : ', ' }}</span>
      </div>
      Reason:
      <span>{{ applicationVersion().branchArchivedReason || '-' }}</span>
    }
  </div>
  @for (config of standaloneActions() | flxOrderBy: 'order'; track config.action) {
    @if (config.visible) {
      <button
        [disabled]="!config.enabled"
        [attr.data-testId]="config.testId"
        [pTooltip]="config.enabled ? '' : config.tooltip"
        (click)="onStandaloneAction(config)"
        class="flx-ds secondary small"
        tooltipStyleClass="text-xs"
        flxButton
      >
        @if (config.icon) {
          <i [class]="config.icon"></i>
        }
        {{ config.label }}
      </button>
    }
  }
</div>

<p-menu
  #branchContextMenu
  [popup]="true"
  [model]="contextMenuItems()"
  styleClass="flx-prime-menu"
  appendTo="body"
  data-testid="branch-context-menu"
/>

<ng-template
  #archiveBranchConfirmation
  let-data
>
  @let deleteState = data.deleteState;
  <div class="flex flex-col gap-2 text-sm">
    <strong>Branch Summary</strong>
    <ul class="list-disc list-inside leading-6">
      @if (deleteState.unmergedCommitCount > 0) {
        <li>
          It has unmerged changes — they are not part of any other branch and stay parked until you
          unarchive and merge.
        </li>
      }
      @if (deleteState.hasWip) {
        <li>A version is work in progress — the current draft is hidden until you unarchive.</li>
      }
      @if (deleteState.hasActiveMerge) {
        <li>Versions already merged into other branches are kept there.</li>
      }
    </ul>
    <flx-input class="flx-ds relative">
      <flx-label class="flx-ds mandatory">Reason</flx-label>
      <input
        [formControl]="archiveReasonFC"
        flxInput
        placeholder="Why is this being archived?"
        maxlength="50"
        data-testId="archive-reason-input"
      />

      @if (archivedActionSubmitted() && archiveReasonFC.invalid) {
        <flx-error>This input is required</flx-error>
      } @else {
        <flx-helper class="flex">&nbsp;</flx-helper>
      }
      <span class="absolute right-0 bottom-0 text-xs text-gray-500"
        >{{ archiveReasonFC.value?.length || 0 }}/50</span
      >
    </flx-input>
  </div>
</ng-template>

<ng-template
  #unarchiveBranchConfirmation
  let-data
>
  @let applicationVersion = data.applicationVersion;
  @let versionCount = data.versionCount;
  <div class="grid grid-cols-[auto_1fr] gap-x-2 gap-y-1 items-center text-sm">
    <span class="font-semibold">Archived by:</span>
    <div class="flex items-center gap-2">
      <span
        [pTooltip]="
          applicationVersion.branchArchivedBy.firstName +
          ' ' +
          applicationVersion.branchArchivedBy.lastName
        "
        class="commit-author text-neutral-900"
        tooltipStyleClass="text-xs"
      >
        {{ applicationVersion.branchArchivedBy | flxUserInitials }}
      </span>
      {{ applicationVersion.branchArchivedDate | flxDateFormat: 'dd MMM yyyy' : 'h:mm a' : ', ' }}
    </div>

    <span class="font-semibold">Reason:</span>
    {{ applicationVersion.branchArchivedReason || '-' }}

    <div class="col-span-2">
      <flx-idea-helper-box>
        Unarchiving restores to the tree as an active one. Its
        {{ versionCount }} versions and history return unchanged, it can be merged again.
      </flx-idea-helper-box>
    </div>
  </div>
</ng-template>
